import { useTranslation } from 'react-i18next';
import StatusLabel from '../../Fundamentals/Label/StatusLabel';
import { packageStatusConfig } from './packageConstants';
import type { VossVersionStatus } from '../../../Constants/VOSS/vossVersionStatus';

interface PackageStatusBadgeProps {
    status: VossVersionStatus | undefined;
    label?: string;
}

const PackageStatusBadge = ({ status, label }: PackageStatusBadgeProps) => {
    const { t } = useTranslation();

    const entry = status === undefined ? undefined : packageStatusConfig[status];
    if (entry === undefined) return null;

    return (
        <StatusLabel variant={entry.variant} disabled={entry.disabled}>
            {label ?? t(entry.labelKey)}
        </StatusLabel>
    );
};

export default PackageStatusBadge;
